import http from '@/lib/http'
// import { apiPrefix } from './apiPrefix'

export default {
  // 查询培训弹窗
  queryTrainingPopup(params) {
    return http.get(`/api/training/popup/query`, {
      params,
      hideGlobalMsg: true,
    })
  },
}
